import { render, staticRenderFns } from "./ReportProject.vue?vue&type=template&id=66b1ec49&"
import script from "./ReportProject.vue?vue&type=script&lang=js&"
export * from "./ReportProject.vue?vue&type=script&lang=js&"
import style0 from "./ReportProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports